import React, { useEffect } from 'react';

export interface MenuItem {
  icon: React.ComponentType<{ size?: number }>;
  label: string;
  onClick: () => void;
  destructive?: boolean;
}

/** Overflow dropdown under the header's ⋯ chip (mobile's NoteMenu). */
export const NoteMenu: React.FC<{ open: boolean; onClose: () => void; items: MenuItem[] }> = ({
  open,
  onClose,
  items,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} aria-hidden />
      <div
        role="menu"
        className="pb-rise absolute right-0 top-12 z-50 min-w-[14rem] overflow-hidden rounded-2xl border border-solid border-outline-variant bg-surface-container-lowest shadow-[0_4px_12px_rgba(28,27,25,0.14)]"
      >
        {items.map(({ icon: Icon, label, onClick, destructive }, i) => (
          <button
            key={label}
            type="button"
            role="menuitem"
            onClick={() => {
              onClose();
              onClick();
            }}
            className={`flex w-full cursor-pointer items-center gap-3 border-0 bg-transparent px-4 py-3.5 text-left font-body text-sm hover:bg-surface-container-high ${
              i > 0 ? 'border-t border-solid border-outline-variant' : ''
            } ${destructive ? 'text-error' : 'text-on-surface'}`}
          >
            <span className={destructive ? 'text-error' : 'text-on-surface-variant'}>
              <Icon size={18} />
            </span>
            {label}
          </button>
        ))}
      </div>
    </>
  );
};
